/** 对话页工具栏偏好：登录用户落库，未登录时仅 localStorage 临时保存。 */

import { api, getAdminToken } from '../api'

const STORAGE_KEY = 'ai_kb_chat_composer_prefs'

export type ChatComposerPrefs = {
  deepThink: boolean
  webSearch: boolean
}

export type ChatComposerPrefsLoaded = ChatComposerPrefs & {
  persisted: boolean
}

const DEFAULT_PREFS: ChatComposerPrefs = {
  deepThink: false,
  webSearch: false,
}

function loadLocalPrefs(): ChatComposerPrefs {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...DEFAULT_PREFS }
    const data = JSON.parse(raw) as Partial<ChatComposerPrefs>
    return {
      deepThink: Boolean(data.deepThink),
      webSearch: Boolean(data.webSearch),
    }
  } catch {
    return { ...DEFAULT_PREFS }
  }
}

function saveLocalPrefs(patch: Partial<ChatComposerPrefs>): void {
  const next = { ...loadLocalPrefs(), ...patch }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch {
    /* ignore */
  }
}

/** 启动时加载：已登录优先读库，否则读 localStorage */
export async function fetchChatComposerPrefs(): Promise<ChatComposerPrefsLoaded> {
  if (!getAdminToken()) {
    return { ...loadLocalPrefs(), persisted: false }
  }
  try {
    const r = await api.get<{
      deep_think: boolean
      web_search: boolean
      persisted: boolean
    }>('/public/chat/preferences')
    const prefs: ChatComposerPrefs = {
      deepThink: Boolean(r.data.deep_think),
      webSearch: Boolean(r.data.web_search),
    }
    if (r.data.persisted) {
      saveLocalPrefs(prefs)
    }
    return { ...prefs, persisted: Boolean(r.data.persisted) }
  } catch {
    return { ...loadLocalPrefs(), persisted: false }
  }
}

/** 切换时保存：已登录写 users 表，未登录仅 localStorage */
export async function persistChatComposerPrefs(
  patch: Partial<ChatComposerPrefs>,
): Promise<{ persisted: boolean }> {
  saveLocalPrefs(patch)
  if (!getAdminToken()) {
    return { persisted: false }
  }
  const body: { deep_think?: boolean; web_search?: boolean } = {}
  if (patch.deepThink !== undefined) body.deep_think = patch.deepThink
  if (patch.webSearch !== undefined) body.web_search = patch.webSearch
  try {
    const r = await api.patch<{
      deep_think: boolean
      web_search: boolean
      persisted: boolean
    }>('/public/chat/preferences', body)
    saveLocalPrefs({
      deepThink: r.data.deep_think,
      webSearch: r.data.web_search,
    })
    return { persisted: true }
  } catch {
    return { persisted: false }
  }
}
